import { api } from '../axiosClient';
import { ExchangeRate } from './exchangeRate.types';

const EXCHANGE_RATE_PATH_1 = 'expense';
const EXCHANGE_RATE_PATH_2 = 'exchange-rate';

export const getExchangeRate = (
  fromCurrencyIsoCode: string,
  toCurrencyIsoCode: string,
  date: string,
  expenseType: 'employee' | 'project',
): Promise<ExchangeRate> => {
  const queryParams = new URLSearchParams({
    fromCurrencyCode: fromCurrencyIsoCode,
    toCurrencyCode: toCurrencyIsoCode,
    date,
  });

  return api.get(
    `/${EXCHANGE_RATE_PATH_1}/${expenseType}/${EXCHANGE_RATE_PATH_2}?${queryParams}`,
  );
};
